module.exports = __webpack_public_path__ + "img/icon2.4cf06ec7.png";